"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _colors = require("@cimpress/react-components/lib/colors");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var FormulaString = function FormulaString(_ref) {
  var children = _ref.children;
  return (
    /*#__PURE__*/
    _react["default"].createElement("code", {
      style: {
        backgroundColor: _colors.silver,
        color: _colors.coal
      }
    }, children)
  );
};

FormulaString.propTypes = {
  children: _propTypes["default"].node.isRequired
};
var _default = FormulaString;
exports["default"] = _default;